module.exports = __webpack_public_path__ + "static/21-04-22_13-35-33_5405-7dd3728766a29be46912192b6cad4d97.jpg";